import { isNullOrEmpty } from "../../utils";
import { isEmpty } from "../../utils/lodash";
import { RandomizationBounds } from "../RandomizationBounds";
import { RandomizationModel } from "../RandomizationModel";
import { RandomizationPattern } from "../enums/RandomizationPattern";

export function createRandomization(el?: any): RandomizationModel {
    if (isEmpty(el)) return undefined;
    return {
        id: el.id,
        pattern: RandomizationPattern[el.pattern as string],
        bounds: createRandomizationBounds(el),
        seedAdjust: el.seedAdjust || el.id,
        groupCount: el.groupCount,
        synchronizedQuestion: el.synchronizedQuestion,
        synchronizedWithId: el.synchronizedWithId,
    };
}

function createRandomizationBounds(el: any): RandomizationBounds {
    if (el.bounds || (el.start && el.end)) {
        const names = !isNullOrEmpty(el.bounds) ? el.bounds.split("-") : undefined;
        const hasNames = names && names.length === 2;
        let startName = hasNames ? names[0] : undefined;
        let endName = hasNames ? names[1] : undefined;

        if (!isNullOrEmpty(el.start)) {
            startName = el.start;
        }

        if (!isNullOrEmpty(el.end)) {
            endName = el.end;
        }

        return {
            startName,
            endName,
        };
    }
    return undefined;
}
